/**
 * Cards flagged with `custom.notify_me_card` on a sold-out product open the
 * Klaviyo back-in-stock modal instead of navigating to the product page.
 *
 * Klaviyo injects its own trigger (`.klaviyo-bis-trigger`) into the
 * `.klaviyo-button-container` the card already renders, and listens for clicks
 * on it. Forwarding the card click to that trigger reuses Klaviyo's own
 * handler, so the modal opens with the right product context.
 *
 * Such a card renders its title links without an href (see card-product.liquid)
 * so the browser doesn't reveal the product URL on hover; preventDefault below
 * still covers any other anchor inside the card.
 */
(() => {
  const CARD_SELECTOR = '[data-notify-me-card]';
  const TRIGGER_SELECTOR = '.klaviyo-bis-trigger';

  document.addEventListener('click', (event) => {
    const card = event.target.closest(CARD_SELECTOR);
    if (!card) return;

    // Klaviyo's own button and any real control keep their default behaviour.
    if (event.target.closest(TRIGGER_SELECTOR)) return;
    if (event.target.closest('button, input, select, textarea')) return;

    const trigger = card.querySelector(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    trigger.click();
  });
})();
